<template>
  <div />
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import {
  openSecondLayer,
  showEmbeddings,
} from 'chimera/all/plugins/config/usercentrics.client'

export default {
  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: undefined,
      headDescription: undefined,
    }
  },

  computed: {
    /**
     * @returns {string}
     */
    currentDate() {
      const date = new Date()
      const day = date.getDate()
      const month = date.toLocaleString(this.$i18n.locale, { month: 'long' })
      const year = date.getFullYear()

      return `${day} ${month} ${year}`
    },
  },

  /**
   */
  created() {
    this.headTitle = this.$t('cookiePolicy.headTitle')
    this.headDescription = this.$t('cookiePolicy.headTitle')
  },

  /**
   *
   */
  mounted() {
    showEmbeddings()
  },

  methods: {
    /**
     *
     */
    openCookieSecondLayer() {
      openSecondLayer()
    },
  },
}
</script>
